import { render } from "./pl5-shi.vue?vue&type=template&id=9f1584de&scoped=true"
import script from "./pl5-shi.vue?vue&type=script&lang=js"
export * from "./pl5-shi.vue?vue&type=script&lang=js"

import "./pl5-shi.vue?vue&type=style&index=0&id=9f1584de&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f1584de"]])

export default __exports__